import React, { useEffect, useState } from "react";
import PieChart from "../charts/PieChart";
import { useGetVisitorsCountByVisitType } from "../../hooks/dashboard/query";
import { PieChartData } from "../../constants/common";
import { useTranslation } from "react-i18next";
import Loader from "../loader";

const VisitorsByTypeCard = () => {
  const { i18n, t } = useTranslation();

  const [visitorsCountByVisitType, setVisitorsCountByVisitType] = useState<
    PieChartData[]
  >([]);

  const {
    data: allVisitorsCountByVisitType,
    isPending: isAllVisitorsCountByVisitTypeLoading,
  } = useGetVisitorsCountByVisitType();

  useEffect(() => {
    if (allVisitorsCountByVisitType) {
      const mappedVisitorsCount = allVisitorsCountByVisitType.map((item) => ({
        name: i18n.language === "en" ? item.visitTypeEn : item.visitTypeAr,
        value: item.visitTypeCount,
      }));

      setVisitorsCountByVisitType(mappedVisitorsCount);
    }
  }, [allVisitorsCountByVisitType, i18n.language]);

  return (
    <div className="bg-white rounded-[15px] px-5 py-4 xl:p-5 flex flex-col gap-7 w-full">
      <div className="flex justify-between items-center gap-2">
        <h1 className="text-xl">{t("visitorsByType")}</h1>
      </div>

      {isAllVisitorsCountByVisitTypeLoading ? (
        <div className="h-[350px] flex justify-center">
          <Loader />
        </div>
      ) : visitorsCountByVisitType.length > 0 ? (
        <PieChart data={visitorsCountByVisitType} innerRadius={15} />
      ) : (
        <div className="h-[350px]">
          <p className="text-xs">{t("noVisitors")}</p>
        </div>
      )}
    </div>
  );
};

export default React.memo(VisitorsByTypeCard);
